import { Button, Divider, Form, FormInstance, Input, notification, PageHeader, Space } from "antd";
import React from "react";
import { APostCreate } from "services/v1/infra-role";
import { SaveButton } from "utils/theme";
import PermissionSelect from "./permission"

interface RoleFormState {
  loading: boolean
}

interface RoleFormProps {
  onClose: () => void
}

const validateMessages = {
  required: `'\${label}' Is a required field`,
};

const request = [{ required: true }];

export default class RoleForm extends React.Component<RoleFormProps, RoleFormState> {

  state: RoleFormState = {
    loading: false
  }

  formRef = React.createRef<FormInstance<Api.V1Component.RoleAddPo>>()

  onFinish = async (formData: Api.V1Component.RoleAddPo) => {
    this.setState({
      loading: true
    })

    const res = await APostCreate({
      roleName: formData.roleName,
      claims: formData.claims
    })

    this.setState({
      loading: false
    })

    if (res.success) {
      notification.success({
        message: 'Add role success.'
      })
      
      this.props.onClose()
    } else {
      notification.error({
        message: res.message
      })
    }
  }

  render () {
    return (
      <>
      <div style={{ width: '100%', height: '100%', background: '#fff' }}>
        <PageHeader onBack={this.props.onClose} title="Add" subTitle="Role" />
        <Divider />
        <Form 
          ref={this.formRef}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={this.onFinish}
          autoComplete="off"
          style={{width: '400px'}}
          validateMessages={validateMessages}
        >
          <Form.Item
            label="Role Name"
            name="roleName"
            rules={request}
          >
            <Input placeholder="Please enter role name"/>
          </Form.Item>

          <Form.Item
            label="Claims"
            name="claims"
            rules={request}
          >
            <PermissionSelect onChange={(value) => this.formRef.current?.setFieldsValue({ claims: value})} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Space>
              <SaveButton loading={this.state.loading} type="primary" htmlType="submit">Submit</SaveButton>
              <Button onClick={this.props.onClose}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
      </>
    )
  }
} 